<style>
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.total-rows {
  padding: 10px;
  font-weight: bold;
}
</style>
<template>
    <div class="card">
      <div class="card-header pb-0 d-flex">
        <h6>Block table</h6>
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search..."
          class="form-control mb-3 ms-auto"
          style="max-width: 250px; "
        />
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Block
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Address
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Details
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Payment
                </th>
                <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Agreement
                </th>
                <th class="text-secondary opacity-7"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(block,index) in paginatedBlock" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ (currentPage-1)*20 + index +1 }}. {{ block.blockid }}</h6>
                      <p class="text-xs text-secondary mb-0">
                        {{ block.blockname}}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ block.address }}</h6>
                  <p class="text-xs text-secondary mb-0">{{ block.remark }}</p>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">Next: {{ block.nextdate }}</p>
                  <p class="text-xs text-secondary mb-0">{{ block.quantity }} PK</p>
                  <p class="text-xs text-secondary mb-0">{{ block.age_cal }} Age</p>
                  <!-- <p class="text-xs text-secondary mb-0">{{ block.est_kg }} KG</p> -->
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">{{ block.term }}</p>
                  <p class="text-xs text-secondary mb-0">RM {{ block.amount }}</p>
                </td>
                <td style="width:10%; word-wrap: break-word; white-space: normal;">
                  <p class="text-xs font-weight-bold mb-0">{{ block.agreement }}</p>
                </td>
                <td class="align-middle">
                  <RouterLink :to="{path : '/editBlock/'+ block.blockid}"
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Edit Block"
                    >Edit
                  </RouterLink>
                </td>
              </tr>
              
            </tbody>
          </table>
          <!-- Pagination Controls -->
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
  </template>

  
<script>
import axios from 'axios';

export default {
  name:'blockSelect',
  data(){
    return {
      totalRows:0,
      currentPage: 1,
      perPage: 20,
      searchQuery:'',
      block: []
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.block.length / this.perPage);
    },
    paginatedBlock() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.block.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getBlockList();
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    getBlockList(){
        axios.get('block/listAllDetails')
            .then(res => {
              console.log(res.data.block);
              this.block = res.data.block;
              this.totalRows = res.data.block.length;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
  },
}
</script>
  